export default __webpack_public_path__ + "static/ab-online-mobile-373e3e025b8c358990c7b54953cbedcf.jpg";